import React from 'react';
import { useRouteMatch } from 'react-router';

import { CompactReport } from 'pages/Private/Launch';
import { ApprovalReportCielo } from 'pages/Private/Launch/approvalReportCielo';
import { ApprovalReportFirst } from 'pages/Private/Launch/approvalReportFirst';
import { FreezingSystemSlas } from 'pages/Private/Launch/FreezingSystemSlas';
import { LaudoTcom } from 'pages/Private/Launch/laudoTcom';
import { LimiteRegistre } from 'pages/Private/Launch/limitRegistre';
import { OsBlock } from 'pages/Private/Launch/osBlock';
import { SystemReport } from 'pages/Private/Launch/systemReport';

import { Route } from '../Route';

export const LaunchRoutes = () => {
  const { url } = useRouteMatch();

  return (
    <>
      <Route isPrivate path={`${url}/compact-report`} component={CompactReport} />
      <Route isPrivate path={`${url}/approval-report-first`} component={ApprovalReportFirst} />
      <Route isPrivate path={`${url}/freezing-system`} component={FreezingSystemSlas} />
      <Route isPrivate path={`${url}/limit-registre`} component={LimiteRegistre} />
      <Route isPrivate path={`${url}/os-block`} component={OsBlock} />
      <Route isPrivate path={`${url}/system-report`} component={SystemReport} />
      <Route isPrivate path={`${url}/approval-report-cielo`} component={ApprovalReportCielo} />
      <Route isPrivate path={`${url}/laudo-tcom`} component={LaudoTcom} />
    </>
  );
};
